<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--차량정보-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001353') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">PMC Id.</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input v-model="pmcId" class="inputWithIcon" readonly></el-input>
										</div>
									</el-col>
								</div>
							</td>
							<th class="col-1">Vin No.</th>
							<td class="col-1"><el-input v-model="carVin" readonly /></td>
							<!--연료전지사양-->
							<th class="col-1">{{ getMessage_('QWCC001021') }}</th>
							<td class="col-1"><el-input v-model="flclSpcNm" readonly /></td>
							<!--차종-->
							<th class="col-1">{{ getMessage_('MWCC000346') }}</th>
							<td class="col-1"><el-input v-model="carTypeNm" readonly /></td>

							<!--HTWO판매일-->
							<th class="col-1">{{ getMessage_('QWCC001044') }}</th>
							<td class="col-1">
								<el-input v-model="erpSaleDd" readonly />
							</td>
						</tr>
						<tr>
							<!--판매사-->
							<th class="col-1">{{ getMessage_('QWCC001045') }}</th>
							<td class="col-1"><el-input v-model="custNm" readonly /></td>
							<!--판매지역-->
							<th class="col-1">{{ getMessage_('QWCC001019') }}</th>
							<td class="col-1">
								<el-input v-model="saleRegnNm" readonly />
							</td>
							<!--보증기간(년)-->
							<th class="col-1">{{ getMessage_('QWCC001351') }}</th>
							<td class="col-1">
								<el-input v-model="usePrdPo" readonly />
							</td>
							<!--보증거리-->
							<th class="col-1">{{ getMessage_('QWCC001023') }}</th>
							<td class="col-1">
								<el-input v-model="milgPo" readonly />
							</td>
							<!--고객사 판매일-->
							<th class="col-1">{{ getMessage_('QWCC001047') }}</th>
							<td class="col-1">
								<el-input v-model="oemSaleDd" readonly />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {
			carVin: '', // 차대번호
			pmcId: '', //PMC번호
			vehlNm: '', //차종명
			vehlCd: '', //차종코드
			carTypeNm: '', //차종유형
			erpSaleDd: '', //HTWO판매일
			custNm: '', //판매사
			saleRegnNm: '', //판매지역
			flclSpcNm: '', //연료전지사양
			usePrdPo: '', //보증사용기간
			milgPo: '', //보증주행거리
			oemSaleDd: '', //고객사판매일
			pmcNoInput: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		setProcessInfo() {
			//스토어에서 값을 가져와서 셋팅한다.
			this.carVin = this.clamMstPopUp.carVin; // Vin No
			this.pmcId = this.clamMstPopUp.pmcId; //pmc id
			//this.vehlNm = this.clamMstPopUp.vehlNm; //차종명
			this.vehlNm = this.clamMstPopUp.vehlCd; //차종명
			this.vehlCd = this.clamMstPopUp.vehlCd; //차종코드
			this.carTypeNm = this.clamMstPopUp.carTypeNm; //차종유형

			this.custNm = this.clamMstPopUp.custNm; //판매사
			this.saleRegnNm = this.clamMstPopUp.saleRegnNm; //판매지역

			this.erpSaleDd = this.clamMstPopUp.erpSaleDd; //HTWO판매일

			this.milgPo = this.clamMstPopUp.milgPo; //보증주행거리
			this.usePrdPo = this.clamMstPopUp.usePrdPo; //보증사용기간

			this.flclSpcNm = this.clamMstPopUp.flclSpcNm; //연료전지사양
			this.oemSaleDd = this.clamMstPopUp.oemSaleDd; //고객판매일
		}
	},
	async created() {
		try {
			//let place1 = this.$sf_formatString(this.getMessage_('QWCC001064'), [this.getMessage_('QWCC000959')]);

			//스토어에서 값을 가져와서 셋팅한다.
			this.carVin = this.clamMstPopUp.carVin; // Vin No
			this.pmcId = this.clamMstPopUp.pmcId; //pmc Id

			this.carTypeNm = this.clamMstPopUp.carTypeNm; //차종유형

			this.custNm = this.clamMstPopUp.custNm; //판매사
			this.saleRegnNm = this.clamMstPopUp.saleRegnNm; //판매지역

			this.erpSaleDd = this.clamMstPopUp.erpSaleDd; //HTWO판매일

			this.milgPo = this.clamMstPopUp.milgPo; //보증주행거리
			this.usePrdPo = this.clamMstPopUp.usePrdPo; //보증사용기간

			this.flclSpcNm = this.clamMstPopUp.flclSpcNm; //연료전지사양
			this.oemSaleDd = this.clamMstPopUp.oemSaleDd; //고객판매일

			//스토어에서 값을 가져와서 셋팅한다.
			//this.dlrCpnyCd = this.clamMstPopUp.dlrCpnyCd; //딜러점코드
			//this.dlrCpnyNm = this.clamMstPopUp.dlrCpnyNm; //딜러점명
			//this.rprRegn = this.clamMstPopUp.rprRegn; //수리지역
			//this.occuRegn = this.clamMstPopUp.occuRegn; //발생지역
			//this.dtlRegn = this.clamMstPopUp.dtlRegn; //지역세부
			//this.causPartNo = this.clamMstPopUp.causPartNo; //원인부품
			//this.causPartNm = this.clamMstPopUp.causPartNm; //원인부품명
			//this.usePrd = this.clamMstPopUp.usePrd; //사용기간
			//this.milg = this.clamMstPopUp.milg; //주행거리
			//this.dgnDd = this.clamMstPopUp.dgnDd; //진단일자
			//this.causCd = this.clamMstPopUp.causCd; //원인코드
			//this.phmnCd = this.clamMstPopUp.phmnCd; //현상코드
			//this.phmnNm = this.clamMstPopUp.phmnNm; //현상코드명
			//this.ctype = this.clamMstPopUp.ctype; //ctypeCd
			//this.dtc1 = this.clamMstPopUp.dtc1; //dtc1
			//this.dtc2 = this.clamMstPopUp.dtc2; //dtc2
			//this.dtc3 = this.clamMstPopUp.dtc3; //dtc3
			//this.prtlSbc = this.clamMstPopUp.prtlSbc; //특이사항
			//this.fileId = this.clamMstPopUp.fileId; //파일Id
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	},
	watch: {}
};
</script>

<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -1px;
}
</style>
